import { hotelAccessCodeCrudConfig } from '@/config/objects/hotel-access-codes';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Hotel Access Code create/edit form page
 */
export function HotelAccessCodeFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  const handleSuccess = (hotelAccessCode: { id: string }) => {
    navigate(`/hotel-access-codes/${hotelAccessCode.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Hotel Access Codes', href: '/hotel-access-codes' },
        { label: 'Access Code', href: `/hotel-access-codes/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Hotel Access Codes', href: '/hotel-access-codes' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={hotelAccessCodeCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
